import { IconWebhook } from '@tabler/icons-react';
import plugLeadLogo from '@assets/logo/partners/plug-lead.png';
import activeCampaignLogo from '@assets/logo/partners/activecampaign.png';

export const PLATFORMS = {
    pluglead: {
        key: 'pluglead',
        name: 'PlugLead',
        logo: plugLeadLogo,
    },
    activecampaign: {
        key: 'activecampaign',
        name: 'ActiveCampaign',
        logo: activeCampaignLogo,
    },
    webhook: {
        key: 'webhook',
        name: 'Webhook',
        logo: null,
        icon: IconWebhook,
    },
};

export const EVENTS = {
    'payments.confirmed': 'Pagamento confirmado',
    'payments.pix_generated': 'Pix gerado',
    'payments.checkout_dropped': 'Checkout abandonado',
};
